export default "__VITE_ASSET__DryH7dF___"